import { PaymentMethodDetailResult } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { AsyncWrapper } from '@mews-commander/ui';
import { usePaymentDetailsSidebarContext } from '../../context/PaymentDetailsSidebarContext';
import { PaymentDetailsSidebarGrid } from '../PaymentDetailsSidebarGrid';
import { PaymentDetailsSidebarRowTypography } from '../PaymentDetailsSidebarRow';
import { CardPaymentMethod } from './CardPaymentMethod';
import { SepaPaymentMethod } from './SepaPaymentMethod';

const UnspecifiedPaymentMethod = () => {
    return (
        <PaymentDetailsSidebarGrid>
            <PaymentDetailsSidebarRowTypography labelTextKey={TextKey.Method} value={TextKey.Unspecified} />
        </PaymentDetailsSidebarGrid>
    );
};

const PaymentMethodSectionContent = ({
    paymentMethodDetailResult,
}: {
    paymentMethodDetailResult: PaymentMethodDetailResult | undefined;
}) => {
    if (!paymentMethodDetailResult) {
        return <UnspecifiedPaymentMethod />;
    }

    const sepaPaymentMethod = paymentMethodDetailResult?.sepa;
    const cardPaymentMethod = paymentMethodDetailResult?.paymentCard;

    if (sepaPaymentMethod) {
        return <SepaPaymentMethod sepaPaymentMethod={sepaPaymentMethod} />;
    }

    if (cardPaymentMethod) {
        return <CardPaymentMethod cardPaymentMethod={cardPaymentMethod} />;
    }

    return <UnspecifiedPaymentMethod />;
};

export const PaymentMethodSection = () => {
    const { paymentMethodDetails, isPaymentMethodDetailsError, isPaymentMethodDetailsFetching } =
        usePaymentDetailsSidebarContext();
    return (
        <AsyncWrapper isFetching={isPaymentMethodDetailsFetching} hasFailed={isPaymentMethodDetailsError}>
            <PaymentMethodSectionContent paymentMethodDetailResult={paymentMethodDetails} />
        </AsyncWrapper>
    );
};
